export default {
  setUserType({ commit }, type) {
    commit("SET_USER_TYPE", type);
  },
};
